import { createStore, applyMiddleware } from 'redux'
import asyncMiddleware from 'redux-async'

import reducer from './reducers'

const { __REDUX_DEVTOOLS_EXTENSION__ = _ => _ } = window
const createStoreWithMiddleware = applyMiddleware(asyncMiddleware)(createStore)

export default createStoreWithMiddleware(reducer, __REDUX_DEVTOOLS_EXTENSION__())
